module.exports = __webpack_public_path__ + "static/media/mini_logo.713916e7.png";